import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  progress: {
    position:'relative'
  },
  border:{
    borderColor:theme.palette.secondary.main
  },
  background: {
    position:'fixed',
    top:'0',
    left:'0',
    width: '100vw',
    height:'100vh',
    backgroundColor:'rgba(0,0,0,0.6)',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    zIndex:'10000000000000000000000'
  }
}));

export default function Loading(props) {
  const classes = useStyles();
  if(props.loading==true){
    if(props.embed==true){
      return (
        <div style={{position:'relative', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <CircularProgress color={(props.color==undefined)?'primary':props.color} size={(props.tiny==true)?30:(props.small==true)?50:75} className={classes.progress}/>
        <div style={{position:'absolute', zIndex:'1', backgroundColor:'white', width:(props.tiny==true)?'20px':(props.small==true)?'44px':'66px', height:(props.tiny==true)?'20px':(props.small==true)?'44px':'66px', borderRadius:'50%'}}>
        </div>
        <div className={classes.border} style={{position:'absolute', zIndex:'100', width:(props.tiny==true)?'20px':(props.small==true)?'20px':'30px', height:(props.tiny==true)?'20px':(props.small==true)?'20px':'30px', display:'flex', justifyContent:'center', alignItems:'center', padding:(props.tiny==true)?'4px':(props.small==true)?'11.33px':'17px', borderRadius:'50%', display:'flex', justifyContent:'center', alignItems:'center', borderWidth:(props.remove_border==true)?'0px':(props.tiny==true)?'1px':(props.small==true)?'2.33px':'3.5px', borderStyle:'solid'}}><img src='/images/logo.png' style={{height:'100%'}}/></div>
        </div>
      );
    }else{
      return (
        <div className={classes.background}>
          <CircularProgress color={(props.color==undefined)?'primary':props.color} size={115} className={classes.progress} loading/>
          <div style={{position:'absolute', width:'75px', height:'75px', backgroundColor:'#eee8f3', display:'flex', justifyContent:'center', alignItems:'center', padding:'18px', paddingTop:'10px', borderRadius:'50%'}}><img src='/images/logo.png' style={{height:'90%'}}/></div>
          {(props.loading_message==undefined)?null:<Typography style={{color:'white', width:'100%', textAlign:'center', position:'absolute', bottom:'50px'}}>{props.loading_message}</Typography>}
        </div>
      );
    }
}else{
  return(
    null
  )
}}
